module["exports"] = [
  "Phd."
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sk/name/suffix.js
 ** module id = 968
 ** module chunks = 0
 **/